import { useSelector } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import CelularMockup from "./CelularMockup";
import { HiOutlineClipboardCopy } from "react-icons/hi";

const GerarLink = () => {
  const username = useSelector((state) => state.user.profile?.username || "");
  const tags = useSelector((state) => state.user.loja?.tags || []);

  const [busca, setBusca] = useState("");
  const [categoria, setCategoria] = useState("");
  const [produtoId, setProdutoId] = useState("");

  const [buscaDebounced, setBuscaDebounced] = useState(busca);
  const [categoriaDebounced, setCategoriaDebounced] = useState(categoria);

  useEffect(() => {
    setBuscaDebounced(busca);
    setCategoriaDebounced(categoria);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBuscaDebounced(busca);
      setCategoriaDebounced(categoria);
    }, 400);

    return () => clearTimeout(timer);
  }, [busca, categoria]);

  const baseUrl = `https://vintree.com.br/${username}`;
  const queryParams = new URLSearchParams({
    busca: buscaDebounced,
    categoria: categoriaDebounced,
    ...(produtoId && { produto: produtoId }),
  });

  const linkFinal = `${baseUrl}?${queryParams.toString()}`;

  const copiarLink = () => {
    navigator.clipboard.writeText(linkFinal);
    alert("Link copiado para a área de transferência!");
  };

  const handleAbrirModal = useCallback((produtoId) => {
    setProdutoId(produtoId);
  }, []);

  const handleFecharModal = () => {
    setProdutoId("");
  };

  if (!username) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center text-gray-500">
          Carregando informações da loja...
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mt-8 lg:mt-2 mb-4 select-none cursor-default">
        Gerador de Links
      </h2>

      <div className="flex flex-col md:flex-row items-center gap-4 mb-6">
        <input
          type="text"
          placeholder="Digite um termo para filtrar..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500"
        />

        <select
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500"
        >
          <option value="">Todas as categorias</option>
          {tags.map((tag) => (
            <option key={tag.id} value={tag.nome}>
              {tag.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-6 text-center">
        <p className="text-blue-600 mb-3 break-all italic">{linkFinal}</p>
        <button
          onClick={copiarLink}
          className="px-4 py-2 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition flex items-center justify-center gap-2 mx-auto"
        >
          <HiOutlineClipboardCopy className="h-5 w-5" />
          <span className="text-sm font-medium">Copiar Link</span>
        </button>
      </div>

      <div className="flex justify-center">
        <CelularMockup
          username={username}
          termoDeBusca={buscaDebounced}
          tag={categoriaDebounced}
          produtoIdSelecionado={produtoId}
          setProdutoIdSelecionado={handleAbrirModal}
          onFecharModal={handleFecharModal}
          tags={tags} // Passa as tags para o mockup
        />
      </div>
    </div>
  );
};

export default GerarLink;
